import { createSelector } from '@reduxjs/toolkit';
import { selectAppServiceState } from '@vlabs/shared/selectors/appSelectors';
import { selectListsState } from '@vlabs/shared/selectors/listSelectors';

import { selectHandlersState } from '@vlabs/pages/handlers/selectors';

export const selectLatestEvents = (state) => state.workspace;
export const selectLatestEventsFilters = (state) => state.workspace.filters;

export const selectNotifyEvents = (state) => state.workspace.notifyEvents;
export const selectViewedNotifyIds = (state) => state.workspace.viewedNotifyIds;
export const selectShownNotifyEventIds = (state) => state.workspace.shownNotifyEvents;

export const selectLatestEventsState = createSelector(
  (state) => selectAppServiceState(state, 'lunaPlatform'),
  selectHandlersState,
  selectListsState,
  (...args) => {
    if (args.every((i) => i === 'loaded')) {
      return 'loaded';
    }
    return 'failed';
  },
);
